export { default } from './AlertsCDS';
